import React, { useState } from 'react';
import { ChevronDownIcon, CornerDownRightIcon, LockIcon, ThumbsUpIcon } from 'lucide-react';
import { CommentAvatar } from './CommentAvatar';
import { comments } from '../data/comments';
import type { CommentReply } from '../data/comments';
const INITIAL_VISIBLE = 9;
type MetaProps = {
  time: string;
  likes: number;
};
function CommentMeta({
  time,
  likes
}: MetaProps) {
  return <div className="mt-1.5 flex flex-wrap items-center gap-x-3 gap-y-1 pl-1 font-sans text-xs text-ink-muted" data-id="element-99" data-mp="1nm7um853r9x5">
      <span className="font-semibold text-[#1877f2]" data-id="element-100" data-mp="1sjzvvsrn08e0">Me gusta</span>
      <span aria-hidden="true" data-id="element-101" data-mp="1wmd20iaaq8bb">·</span>
      <span className="font-semibold text-[#1877f2]" data-id="element-102" data-mp="1wnfrqmvvu4pn">Responder</span>
      <span aria-hidden="true" data-id="element-103" data-mp="21l7k1i0fvsud">·</span>
      <span data-id="element-104" data-mp="21k687bbln2bl">{time}</span>
      <span className="flex items-center gap-1" data-id="element-105" data-mp="21ko9imd4c6qd">
        <ThumbsUpIcon className="h-3 w-3 fill-[#1877f2] text-[#1877f2]" aria-hidden="true" data-id="element-106" data-mp="2952wefafajv" />
        {likes}
      </span>
    </div>;
}
function ReplyItem({
  reply
}: {
  reply: CommentReply;
}) {
  return <li className="flex gap-2.5" data-id="element-107" data-mp="ha5skyjakbe8">
      <CommentAvatar name={reply.name} initials={reply.initials} color={reply.avatarColor} src={reply.avatar} size="sm" data-id="element-108" data-mp="hb75z9ns59z4" />
      <div className="min-w-0" data-id="element-109" data-mp="8infwxlk0dpw">
        <div className="rounded-lg bg-neutral-100 px-4 py-3" data-id="element-110" data-mp="8hu4hjbnh01f">
          <p className="font-sans text-sm font-semibold text-ink" data-id="element-111" data-mp="3jakvpkj40c8">
            {reply.name}{' '}
            <span className="font-normal text-ink-muted" data-id="element-112" data-mp="1091l85fi4hpy">respondió a {reply.replyingTo}</span>
          </p>
          <p className="mt-1 font-serif text-[0.95rem] leading-relaxed text-ink" data-id="element-113" data-mp="w8817n56jn2c">{reply.body}</p>
        </div>
        <CommentMeta time={reply.time} likes={reply.likes} data-id="element-114" data-mp="r6scnl3smyf7" />
      </div>
    </li>;
}
export function CommentsSection() {
  const [showAll, setShowAll] = useState(false);
  const visible = showAll ? comments : comments.slice(0, INITIAL_VISIBLE);
  const remaining = comments.length - INITIAL_VISIBLE;
  return <section aria-labelledby="comentarios-titulo" className="border-t border-brand-blush pt-8" data-id="element-115" data-mp="36xn2ufjum1fv">
      <div className="flex items-baseline justify-between gap-4" data-id="element-116" data-mp="38gwqgpsg5l55">
        <h2 id="comentarios-titulo" className="font-sans text-xl font-bold text-ink" data-id="element-117" data-mp="3dfq7utautwal">
          Comentarios (124)
        </h2>
        <span className="font-sans text-xs text-ink-muted" data-id="element-118" data-mp="2zf6ztm6e2q8f">Ordenar por: Más relevantes</span>
      </div>

      <div className="mt-5 flex items-center gap-3 rounded-sm border border-neutral-200 bg-neutral-50 px-4 py-3" aria-hidden="true" data-id="element-119" data-mp="34d8l8draf1n2">
        <span className="h-9 w-9 shrink-0 rounded-full bg-neutral-300" data-id="element-120" data-mp="2uh5jva49f716" />
        <span className="font-sans text-sm text-ink-muted" data-id="element-121" data-mp="2gp7ftdpeo1bv">Escribe un comentario…</span>
        <span className="ml-auto flex items-center gap-1.5 font-sans text-[0.7rem] font-semibold uppercase tracking-wide text-ink-muted" data-id="element-122" data-mp="2gne6trrbl50p">
          <LockIcon className="h-3.5 w-3.5" data-id="element-123" data-mp="26qrn56aqck09" />
          Cerrado
        </span>
      </div>
      <p className="mt-2 font-sans text-xs text-ink-muted" data-id="element-124" data-mp="2bqnrx7r94fgv">
        Los comentarios de este artículo han sido cerrados temporalmente por volumen de tráfico.
      </p>

      <ul className="mt-7 space-y-6" data-id="element-125" data-mp="1s6f7jn5sqr9k">
        {visible.map(comment => <li key={comment.id} className="flex gap-3" data-id="element-126" data-mp="1n6ssr9abl2yn">
            <CommentAvatar name={comment.name} initials={comment.initials} color={comment.avatarColor} src={comment.avatar} data-id="element-127" data-mp="2231q25anh68f" />
            <div className="min-w-0 flex-1" data-id="element-128" data-mp="2b2x2edfxz7a1">
              <div className="rounded-lg bg-neutral-100 px-4 py-3" data-id="element-129" data-mp="2b1m2iopmajo7">
                <p className="font-sans text-sm font-semibold text-ink" data-id="element-130" data-mp="264vm209whm29">{comment.name}</p>
                <p className="mt-1 font-serif text-[0.95rem] leading-relaxed text-ink" data-id="element-131" data-mp="2ktjdbucpr9me">
                  {comment.body}
                </p>
              </div>
              <CommentMeta time={comment.time} likes={comment.likes} data-id="element-132" data-mp="2fvzyas86yste" />

              {comment.replies && comment.replies.length > 0 && <div className="mt-3" data-id="element-133" data-mp="2psmidesp1fud">
                  <p className="flex items-center gap-1.5 pl-1 font-sans text-xs font-semibold text-ink-soft" data-id="element-134" data-mp="2ptxohl9m2zon">
                    <CornerDownRightIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-135" data-mp="n3bk3lkt8iwt" />
                    {comment.replies.length === 1 ? '1 respuesta' : `${comment.replies.length} respuestas`}
                  </p>
                  <ul className="mt-3 space-y-4 border-l-2 border-neutral-200 pl-3 sm:pl-4" data-id="element-136" data-mp="11tact8tlj24w">
                    {comment.replies.map(reply => <ReplyItem key={reply.id} reply={reply} data-id="element-137" data-mp="48wkbtqocm7x" />)}
                  </ul>
                </div>}
            </div>
          </li>)}
      </ul>

      {!showAll && remaining > 0 ? <div className="mt-7 text-center" data-id="element-138" data-mp="i6l40y909nbe">
          <button type="button" onClick={() => setShowAll(true)} className="inline-flex items-center gap-1.5 rounded-sm px-4 py-2 font-sans text-sm font-semibold text-[#1877f2] transition-colors duration-150 ease-out hover:bg-neutral-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#1877f2]" data-id="element-139" data-mp="i7nvp8e5jtsd">
            Ver más comentarios ({remaining})
            <ChevronDownIcon className="h-4 w-4" aria-hidden="true" data-id="element-140" data-mp="3a2qke4z3kssi" />
          </button>
        </div> : <p className="mt-7 text-center font-sans text-sm text-ink-muted" data-id="element-141" data-mp="358vugjswfhkz">Cargando más comentarios…</p>}
    </section>;
}